import styled from 'styled-components';
import * as variables from './../../../assets/css/variables';

export const FormGroup = styled.fieldset`
  border-color: transparent;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  
  label {
    font-size: 1.2857142857142858rem;
    margin-bottom: 1.0714285714285714rem;
    color: #000;
  }
  
  input {
    border-color: #D3D3D3;
    font-size: 1.2857142857142858rem;
  }
  
  output {
    font-size: 0.8571428571428571rem;
    padding: .5rem;
    color: red;
    background-color: #FCE9ED;
  }
  
  .help_block {
    margin-top: 1rem;
    color: #64C3E0;
    font-size: .9rem;
    text-transform: uppercase;
  }
  
  @media (max-width: ${variables.TABLET}) {
        label {
            font-size: 0.8571428571428571rem;
            margin-bottom: 0.7142857142857143rem;
        }
        
        input {
            font-size: 1rem;
        }
  }
`;